import { forwardRef } from 'react';

import BottleAddProduct from '@/assets/images/bottle-add-product.svg';

import type { PolymorphicRef } from '@/types';
import type { ElementType } from 'react';
import type { TypeCardAddProductProps } from './types';

/**
 * CardAddProduct
 */
const Basic = <T extends ElementType = 'button'>(
  {
    className = '',
    height = '195',
    width = '58',
    as,
    ...props
  }: TypeCardAddProductProps<T>,
  ref?: PolymorphicRef<T>,
) => {
  const HTMLTag = as || 'button';

  return (
    <HTMLTag
      ref={ref}
      className={`group grid place-items-center bg-bg-secondary p-4 outline outline-1 outline-primary-200 ${className}`}
      {...props}
    >
      <BottleAddProduct
        height={height}
        width={width}
        className="text-primary-400 transition-transform group-hover:scale-105"
      />
    </HTMLTag>
  );
};

Basic.displayName = 'CardAddProduct';

export const CardAddProduct = forwardRef(Basic);
